<script>
import SimpleGroupSelect from '../UI/Form/SimpleGroupSelect.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import { Routes } from '../../../../Constants/Routes.ts'
import Role from '../../../../Constants/Role.ts'

export default {
  components: { SimpleGroupSelect },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    entityId: [String, Number],
    entityName: String,
  },
  computed: {
    menuItems() {
      return [
        {
          label: this.$t('entity.menu.society'),
          route: {
            name: Routes.ENTITY_VIEW_INFORMATION,
          },
        },
        {
          label: this.$t('entity.menu.financialStatement'),
          route: {
            name: Routes.ENTITY_VIEW_FINANCIAL_STATEMENTS,
          },
          enabled: conf.entity_show_financial,
        },
        {
          label: this.$t('entity.menu.documents'),
          route: {
            name: Routes.ENTITY_VIEW_DOCUMENTS,
          },
          enabled: this.hasRole('ROLE_DOCUMENT_ENTITY_SHOW'),
        },
        {
          label: this.$t('entity.menu.proposal'),
          route: {
            name: Routes.ENTITY_VIEW_PROPOSALS,
          },
        },
        {
          label: this.$t('entity.menu.demand'),
          route: {
            name: Routes.ENTITY_VIEW_DEMANDS,
          },
          enabled: this.hasRole(Role.DEMAND) || this.hasRole(Role.DEMANDS),
        },
        {
          label: this.$t('entity.menu.contract'),
          route: {
            name: Routes.ENTITY_VIEW_CONTRACTS,
          },
        },
        {
          label: this.$t('entity.menu.invoice.client'),
          route: {
            name: Routes.ENTITY_VIEW_CLIENT_INVOICES,
          },
          enabled: this.hasRole('ROLE_INVOICE_ENTITY'),
        },
        {
          label: this.$t('entity.menu.invoice.supplier'),
          route: {
            name: Routes.ENTITY_VIEW_SUPPLIER_INVOICES,
          },
          enabled: this.hasRole('ROLE_INVOICE_ENTITY'),
        },
      ]
    },
    availableMenuItems() {
      return this.menuItems.filter(({ enabled = true }) => enabled)
    },
  },

  methods: {
    redirectToPage(page) {
      const selectedMenu = this.menuItems.find((item) => item.value === page)

      if (selectedMenu) {
        this.$router.push(selectedMenu.route)
      }
    },
  },
}
</script>
<template>
  <div class="topbar-submenu row">
    <div class="topbar-simulation-title col-md-4 align-self-center">{{ entityName }}</div>
    <div class="mobile-menu">
      <SimpleGroupSelect
        class-label="text-white"
        :label="$t('menu.select')"
        :value="$route.name"
        @transmitted="redirectToPage"
      >
        <option
          v-for="menu in availableMenuItems"
          :key="menu.route.name"
          :selected="menu.selected"
          :value="menu.route.name"
        >
          {{ menu.label }}
        </option>
      </SimpleGroupSelect>
    </div>
    <div class="device-menu row col">
      <div class="topbar-submenu-link" v-for="menu in availableMenuItems" :key="menu.route.name">
        <RouterLink :to="menu.route" exact-active-class="sub-active">
          {{ menu.label }}
        </RouterLink>
      </div>
    </div>
  </div>
</template>
